import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { SnackBarData } from '../models/snack-bar-config';

export const snackBarConfig: MatSnackBarConfig<SnackBarData> = {
  duration: 2000,
  horizontalPosition: 'end',
  verticalPosition: 'bottom',
  panelClass: ['qac-snack-bar']
};
